import React, { useEffect, useRef, useState } from "react";
import { ConsultaPedidoRelatorioRomaneio, ConsultaProdImpressao} from "../funcionalidades/bancoGet";
import { useNavigate } from "react-router-dom";

import GlobalVar from "../subComponents/GlobalVar";
import TopMenu from '../TopMenu'
import { useSearchParams } from "react-router-dom";
import JsBarcode from "jsbarcode";



async function imprimeEtiquetaRoma(resp){
  const produtosTMP = await {}
  for (const produtoRoma of resp.itens) {
                              const {fabricante, codigopro, qtde} = produtoRoma;
                          
                              try {
                                  const resposta = await ConsultaProdImpressao({ 
                                  codFornecedor: parseInt(fabricante.split(" - ")[0].match(/\d+/)[0],10), 
                                  codItem: codigopro, quantidade: qtde });
                          
                                  if (resposta.Error || resposta["ERROR SERVER"]) {
                                      Swal.fire({
                                          icon: "warning",
                                          title: "Algo deu errado",
                                          text: "Problema no servidor."
                                      });
                                  } else {
                                      produtosTMP[resposta[0].produtos_num_item + "" + resposta[0].produtos_num_fornecedor] = resposta[0];
                                  }
                          
                              } catch (error) {
                                  console.error("Erro na chamada:", error);
                              }
                          }
                          await GlobalVar.setLocalStorage("produtoImpressaoEtiquetaPDF", produtosTMP)
                          const valor = prompt("Digite o numero posicao das etiquetas que deseja gerar (Ex.: 1):");
                          console.log("PROMPT")
                          console.log(valor)
                          if (valor) {
                            // redireciona passando o valor na URL
                            await GlobalVar.setLocalStorage("posicaoImpressaoEtiquetaPDF", parseInt(valor))
                            window.open('/GeraPdfProdutoImpressao', '_blank');
                          }
                          
  return;
}

const PedidoRelatorioRomaneio = ({ativaResp, showStyle}) => {

    // const navigate = useNavigate();
    

    useEffect(()=>{
        if(!showStyle) return;
        import('../../assets/css/auxiliar/scrolbar.css')
        import('../../assets/css/estiloPaginas/consultaPedidoRelatorioRomaneio.css')
    },[])




    const [usuario, setUsuario] = useState(GlobalVar.getSessionStorage('usuario'));
    const [notaInfo, setNotaInfo] = useState(null);
    const [itensNotaTratada, setItensNotaTratada] = useState(null);
    const [searchParams] = useSearchParams();
    const documento = searchParams.get("doc");


    useEffect(()=>{
        if(!usuario || !documento) return;
            ConsultaPedidoRelatorioRomaneio({DOCUMENTO: documento})
                .then((resp)=>{
                    if(resp.Error){
                        
                    }else{
                        setNotaInfo(resp)
                        const respostaTratada = resp.itens.reduce((acc, curr) => {
                            if(!acc[curr.rev_nom]) {
                                acc[curr.rev_nom] = [];
                            }
                            acc[curr.rev_nom].push(curr);
                            return acc;
                        }, {});
                        setItensNotaTratada(respostaTratada)
                        imprimeEtiquetaRoma(resp)
                        
                    }
                })
        
    },[usuario, documento])


    const barcodeRef = useRef(null);

    useEffect(() => {
        if (barcodeRef.current && notaInfo) {
        JsBarcode(barcodeRef.current, `088${notaInfo.cabecalho.documento.padStart(10, "0")}`, {
            displayValue: true,
            height: 80,
            margin: 0,
        });
        }
    }, [barcodeRef, notaInfo]);

    if (!usuario || !notaInfo) {
        return <div>Carregando...</div>;
      }

    return <>
            {/* <div className="container mx-auto"> */}
            <div className="containerPrincipal consultaPedidoRelatorioRomaneio" style={{minHeight: "90vh", /*maxHeight: windowHeight*0.80,*/ display: 'flex',
    flexDirection: 'column', /*overflowY: "hidden"*/}}>

                {/* {notaInfo ? JSON.stringify(notaInfo) : ''} */}

                <div className="titleDoc">Romaneio Pedido App Encomendas</div>
                <div className="infocabecalho">
                    <div className="nomeCliente">Cliente: {notaInfo.cabecalho.nomeclie}</div>
                    <div className="dataPedido">{GlobalVar.converterDataISOParaFormatoBR(notaInfo.cabecalho.data)}</div>
                    <div className="numeroPedido">Número do Pedido: {notaInfo.cabecalho.documento_origem}</div>
                    <div className="numeroRomaneio">Número do Romaneio: {notaInfo.cabecalho.documento}</div>
                    <div className="numeroLoja">LOJA DESTINO: {notaInfo.cabecalho.loja}</div>
		    <div className="numeroRomaneio">VENDEDORA: {notaInfo.cabecalho.ven_nome}</div>
                </div>


                <div className="titleComp">Informações Complementares</div>

                <div className="subtitleComp">• Resumo das Peças a serem entregues</div>
                <div className="divisor divisorResumo"></div>
                {Object.keys(itensNotaTratada).map((revistaColecaoItens,i)=>{
                    const itensArr = itensNotaTratada[revistaColecaoItens]
                    
                    return <>

                    <div className="titleRevMov fornecedor" key={`title${notaInfo.cabecalho.documento_origem}`}>{revistaColecaoItens}</div>
                        <div className="itemsMov fornecedor" key={`itens${notaInfo.cabecalho.documento_origem}`}>

                            {itensArr.map((subItem,i)=>{
                               return <> 
                                <div className="subItemMov fornecedor" key={`subItens${notaInfo.cabecalho.documento_origem}`}>
                                    <div>{subItem.fabricante.substr(0,24)}</div>
                                    <div>{subItem.item.substr(0,38)}</div>
                                    <div>COR: {subItem.procor_descricao_cor.substr(0,12)}</div>
                                    <div>TAM.: {subItem.tam_nom}</div>
                                    <div>{`${subItem.qtde}`} UN</div>
                                </div>
                                <div className='lineBar'></div>
                            </>
                            })}
                            <div className="totalItemMov">
                                <div>Subtotal</div>
                                <div>Items: {`${itensArr.reduce((acc, curr) => {
                                            return acc + parseInt(curr.qtde);
                                        }, 0)}`}</div>
                            </div>
                            
                        </div>

                        </>
                    })}
                    
                    
                    <div className="totalItemMovTotal">
                            <div>Total</div>
                            <div>Items: {`${notaInfo.cabecalho.totalitens}`}</div>
                            <div>Valor: {`${notaInfo.cabecalho.totalgeral}`}</div>
                        </div>
                    
                    <div className="divisor divisorResumoEnd"></div>
                    <div className="subInfoBarCode">Código para Entrada em lote do pedido</div>

                    <svg className="barcode" ref={barcodeRef}></svg>
        </div>
           </>
}

export default PedidoRelatorioRomaneio;
